const VIEWKEY = 'collectionView',
      TRANSITIONCLASS = 'transitioning',
      CURRENT_URL = new URL(window.location.href),
      CURRENT_URL_PARAMS = new URLSearchParams(CURRENT_URL.search),
      MASTER_PARAM = 'master_ids';

class CollectionProducts extends HTMLElement {
  constructor() {
    super();
    this.productsContainer = this.querySelector('.collection-grid__products');
    this.displayForm = this.querySelector('.settings-display');
    this.sortingSelect = this.querySelector('.sorting-options form');

    this.masterProducts = this.querySelector('.collection-grid__master-products');
    this.masterProductsContainer = this.querySelector('.master-products__content .content-products');

    this.setupEventListeners();
    this.checkView();
    if (this.classList.contains('brand-collection')) this.checkMasterProducts();
  }
    
  setupEventListeners() {
    this.displayForm.addEventListener('change', () => {
      const displayValue = this.displayForm.querySelector('input[name="display"]:checked').id;
      this.switchView(displayValue);
    });

    this.sortingSelect.addEventListener('change', () => {
      const sortingOption = this.sortingSelect.querySelector('input:checked').value;

      CURRENT_URL_PARAMS.set('sort_by', sortingOption);
      window.location.replace(CURRENT_URL.toString().split('?')[0] + '?' + CURRENT_URL_PARAMS.toString());
    });

    document.addEventListener('quantityUpdated', () => this.checkSamplesCount());
  }

  checkView() {
    const customerView = localStorage.getItem(VIEWKEY);
    if (!this.productsContainer.classList.contains(customerView) && customerView != null) this.switchView(customerView);
  }

  switchView(view) {
    this.productsContainer.classList.add(TRANSITIONCLASS);
    view == 'grid' ? this.productsContainer.classList.remove('list') : this.productsContainer.classList.add('list');
    setTimeout(() => {
      this.querySelector('#' + view).checked = true;
      localStorage.setItem(VIEWKEY, view);
      this.productsContainer.classList.remove(TRANSITIONCLASS);
    }, 250);
  }
  
  checkSamplesCount() {
    const samplesButton = Array.from(this.querySelectorAll('.sample-cta:not(.hidden):not(.soldout)')),
          updateButtons = (disable, content, remove, add) => {
            samplesButton.forEach((item) => {
              item.disabled = disable;

              const button = item.querySelector('.button-content');
              button.textContent = content;
              button.classList.remove(remove);
              button.classList.add(add);
            });
          };
    
    if (samplesCount >= samples.max_amount) {
      updateButtons(true, tokens.samples_max_reached, 'font-focus', 'font-message');
    } else {
      updateButtons(false, tokens.add, 'font-message', 'font-focus');
    }
  }

  checkMasterProducts() {
    const collectionHandle = window.location.href.split('/collections/')[1].split('?')[0];

    fetch(`/collections/${collectionHandle}/?filter.p.m.dependent.is_master=true&section_id=master-products`)
      .then((response) => {
        if (!response.ok) {
          console.log(response.status);
        }
        return response.text();
      })
      .then((text) => {
        const htmlObject = document.createElement('div');

        htmlObject.innerHTML = text;
        if (htmlObject.querySelector('master-products').innerHTML !== '') {
          this.masterProductsContainer.insertAdjacentHTML('beforeend', htmlObject.querySelector('master-products').innerHTML);
          this.masterProducts.classList.remove('hidden');
          this.productsContainer.querySelectorAll('.card-product.master-product').forEach((card) => card.classList.add('hidden'));

          if (CURRENT_URL_PARAMS.has(MASTER_PARAM)) this.focusOnMasterProducts();
        }
      })
  }

  focusOnMasterProducts() {
    let focusedIds = CURRENT_URL_PARAMS.get(MASTER_PARAM);

    focusedIds = focusedIds.split(',');
    setTimeout(() => {
      focusedIds.forEach((id) => {
        if (this.masterProducts.querySelector(`[data-id="${id}"]`) != null) {
          this.masterProducts.querySelector(`[data-id="${id}"]`).classList.add('focused');
        }
      });
      this.masterProducts.scrollIntoView({block: 'center'});
    }, 250);
  }
}

customElements.define('collection-products', CollectionProducts);
